export const GENERIC_UPLOAD_ERROR = "Failed to upload file."
// NOTE longer than this is almost certainly not a message meant for the user (e.g. a stack trace)
export const MAX_ERROR_MESSAGE_LENGTH = 300

/**
 * The file-too-large message, shared by dropzone's client-side check and the server's 413, so the user sees
 * the same text wherever the size limit is caught
 *
 * @param maxFileSizeMB the size limit in MB
 * @returns the message to show the user
 */
export function fileTooLargeMessage(maxFileSizeMB: number): string {
    return `File is too large. Maximum allowed size is ${maxFileSizeMB}MB.`
}

/**
 * Turns a dropzone upload error into a message that's safe to show the user. The server's own messages
 * (e.g. the 413 file-too-large text) pass through, anything else falls back to a generic message.
 *
 * @param message the error dropzone reports: the response body, or an object for non-text responses
 * @returns the message to show in the error toast
 */
export function toUserFacingErrorMessage(message: string | Record<string, unknown>): string {
    if (typeof message !== "string") return GENERIC_UPLOAD_ERROR
    // NOTE a proxy in front of the server (e.g. nginx 413/502) responds with an HTML page, not a message
    const looksLikeHtml = /<\/?[a-z!][^>]*>/i.test(message)
    if (looksLikeHtml || message.trim() === "" || message.length > MAX_ERROR_MESSAGE_LENGTH) return GENERIC_UPLOAD_ERROR

    return message
}
